// extracted by mini-css-extract-plugin
module.exports = {"slide":"SlideGallery_slide__0SkAe","thumbs":"SlideGallery_thumbs__PTw3Q"};